import { useState, useRef } from 'preact/hooks'
import type { ChatAttachment } from '../types'
import { AttachmentPicker } from './AttachmentPicker'

const EMOJI_GROUPS: Record<string, string[]> = {
  'Smileys': [
    '\u{1F600}', '\u{1F603}', '\u{1F604}', '\u{1F601}', '\u{1F606}', '\u{1F605}', '\u{1F923}', '\u{1F602}',
    '\u{1F642}', '\u{1F643}', '\u{1F609}', '\u{1F60A}', '\u{1F607}', '\u{1F970}', '\u{1F60D}', '\u{1F929}',
    '\u{1F618}', '\u{1F617}', '\u{1F61A}', '\u{1F619}', '\u{1F60B}', '\u{1F61B}', '\u{1F61C}', '\u{1F92A}',
    '\u{1F61D}', '\u{1F911}', '\u{1F917}', '\u{1F92D}', '\u{1F92B}', '\u{1F914}', '\u{1F910}', '\u{1F928}',
    '\u{1F610}', '\u{1F611}', '\u{1F636}', '\u{1F60F}', '\u{1F612}', '\u{1F644}', '\u{1F62C}', '\u{1F925}',
    '\u{1F60C}', '\u{1F614}', '\u{1F62A}', '\u{1F924}', '\u{1F634}', '\u{1F637}', '\u{1F912}', '\u{1F915}',
    '\u{1F922}', '\u{1F92E}', '\u{1F927}', '\u{1F975}', '\u{1F976}', '\u{1F974}', '\u{1F635}', '\u{1F92F}',
    '\u{1F920}', '\u{1F973}', '\u{1F978}', '\u{1F60E}', '\u{1F913}', '\u{1F9D0}', '\u{1F615}', '\u{1F61F}',
    '\u{1F641}', '\u{2639}\u{FE0F}', '\u{1F62E}', '\u{1F62F}', '\u{1F632}', '\u{1F633}', '\u{1F97A}', '\u{1F626}',
    '\u{1F627}', '\u{1F628}', '\u{1F630}', '\u{1F625}', '\u{1F622}', '\u{1F62D}', '\u{1F631}', '\u{1F616}',
    '\u{1F623}', '\u{1F61E}', '\u{1F613}', '\u{1F629}', '\u{1F62B}', '\u{1F971}', '\u{1F624}', '\u{1F621}',
    '\u{1F620}', '\u{1F92C}', '\u{1F608}', '\u{1F47F}', '\u{1F480}', '\u{1F4A9}', '\u{1F921}', '\u{1F479}',
    '\u{1F47A}', '\u{1F47B}', '\u{1F47D}', '\u{1F916}', '\u{1F383}', '\u{1F638}', '\u{1F639}', '\u{1F63A}',
    '\u{1F63B}', '\u{1F63C}', '\u{1F63D}', '\u{1F640}', '\u{1F63F}', '\u{1F63E}', '\u{1F648}', '\u{1F649}',
    '\u{1F64A}', '\u{1F485}', '\u{1F4AA}', '\u{1F9BE}', '\u{1F9BF}', '\u{1F442}', '\u{1F443}', '\u{1F9E0}',
    '\u{1F9B7}', '\u{1F9B4}', '\u{1F441}\u{FE0F}', '\u{1F445}', '\u{1F444}', '\u{1F476}', '\u{1F9D2}', '\u{1F466}',
    '\u{1F467}', '\u{1F9D1}', '\u{1F468}', '\u{1F469}', '\u{1F9D3}', '\u{1F474}', '\u{1F475}',
  ],
  'Gestures & People': [
    '\u{1F44B}', '\u{1F91A}', '\u{1F590}\u{FE0F}', '\u{270B}', '\u{1F596}', '\u{1F44C}', '\u{1F90F}', '\u{270C}\u{FE0F}',
    '\u{1F91E}', '\u{1FAF0}', '\u{1F91F}', '\u{1F918}', '\u{1F919}', '\u{1F448}', '\u{1F449}', '\u{1F446}',
    '\u{1F595}', '\u{1F447}', '\u{261D}\u{FE0F}', '\u{1F44D}', '\u{1F44E}', '\u{270A}', '\u{1F44A}', '\u{1F91B}',
    '\u{1F91C}', '\u{1F44F}', '\u{1F64C}', '\u{1FAF6}', '\u{1F450}', '\u{1F932}', '\u{1F91D}', '\u{1F64F}',
    '\u{270D}\u{FE0F}', '\u{1F485}', '\u{1F933}', '\u{1F4AA}', '\u{1F9B5}', '\u{1F9B6}', '\u{1FAC2}', '\u{1F468}\u{200D}\u{1F4BB}',
    '\u{1F469}\u{200D}\u{1F4BB}', '\u{1F9D1}\u{200D}\u{1F4BB}', '\u{1F9D1}\u{200D}\u{1F393}', '\u{1F9D1}\u{200D}\u{1F3EB}', '\u{1F9D1}\u{200D}\u{1F52C}', '\u{1F9D1}\u{200D}\u{1F3A8}', '\u{1F9D1}\u{200D}\u{1F680}', '\u{1F9D1}\u{200D}\u{1F692}',
    '\u{1F46E}', '\u{1F575}\u{FE0F}', '\u{1F482}', '\u{1F977}', '\u{1F933}', '\u{1F470}', '\u{1F935}', '\u{1F931}',
  ],
  'Hearts & Symbols': [
    '\u{2764}\u{FE0F}', '\u{1F9E1}', '\u{1F49B}', '\u{1F49A}', '\u{1F499}', '\u{1F49C}', '\u{1F90E}', '\u{1F5A4}',
    '\u{1FA76}', '\u{1FA75}', '\u{1F90D}', '\u{1F49E}', '\u{1F495}', '\u{1F49F}', '\u{2763}\u{FE0F}', '\u{1F494}',
    '\u{2764}\u{FE0F}\u{200D}\u{1FA79}', '\u{1F498}', '\u{1F49D}', '\u{1F496}', '\u{1F497}', '\u{1F493}', '\u{1F48C}', '\u{1F48B}',
    '\u{1F4AF}', '\u{1F4A2}', '\u{1F4A5}', '\u{1F4AB}', '\u{1F4A6}', '\u{1F4A8}', '\u{1F573}\u{FE0F}', '\u{1F4A3}',
    '\u{1F4AC}', '\u{1F441}\u{FE0F}\u{200D}\u{1F5E8}\u{FE0F}', '\u{1F5E8}\u{FE0F}', '\u{1F5EF}\u{FE0F}', '\u{1F4AD}', '\u{1F4A4}', '\u{1F31F}', '\u{2728}',
    '\u{26A1}', '\u{1F525}', '\u{2604}\u{FE0F}', '\u{2600}\u{FE0F}', '\u{1F31E}', '\u{1F31D}', '\u{1F31B}', '\u{1F31C}',
    '\u{1F319}', '\u{1F311}', '\u{1F313}', '\u{1F315}', '\u{1F317}', '\u{2B50}', '\u{1F320}', '\u{1F4AB}',
  ],
  'Animals & Nature': [
    '\u{1F436}', '\u{1F431}', '\u{1F42D}', '\u{1F439}', '\u{1F430}', '\u{1F98A}', '\u{1F43B}', '\u{1F43C}',
    '\u{1F428}', '\u{1F42F}', '\u{1F981}', '\u{1F42E}', '\u{1F437}', '\u{1F43D}', '\u{1F438}', '\u{1F435}',
    '\u{1F648}', '\u{1F649}', '\u{1F64A}', '\u{1F412}', '\u{1F414}', '\u{1F427}', '\u{1F426}', '\u{1F424}',
    '\u{1F423}', '\u{1F425}', '\u{1F986}', '\u{1F985}', '\u{1F989}', '\u{1F9A2}', '\u{1F99A}', '\u{1F99C}',
    '\u{1F9A9}', '\u{1F9A4}', '\u{1F993}', '\u{1F40E}', '\u{1F984}', '\u{1F993}', '\u{1F98C}', '\u{1F410}',
    '\u{1F411}', '\u{1F40F}', '\u{1F42A}', '\u{1F42B}', '\u{1F999}', '\u{1F992}', '\u{1F418}', '\u{1F98F}',
    '\u{1F99B}', '\u{1F40D}', '\u{1F98E}', '\u{1F432}', '\u{1F409}', '\u{1F995}', '\u{1F996}', '\u{1F433}',
    '\u{1F40B}', '\u{1F42C}', '\u{1F41F}', '\u{1F420}', '\u{1F421}', '\u{1F988}', '\u{1F419}', '\u{1F41A}',
    '\u{1F40C}', '\u{1F98B}', '\u{1F41B}', '\u{1F41C}', '\u{1F41D}', '\u{1F41E}', '\u{1F997}', '\u{1F577}\u{FE0F}',
    '\u{1F578}\u{FE0F}', '\u{1F982}', '\u{1F980}', '\u{1F990}', '\u{1F991}', '\u{1F9AB}', '\u{1F9A8}', '\u{1F9A1}',
    '\u{1F33F}', '\u{1F340}', '\u{1F341}', '\u{1F342}', '\u{1F343}', '\u{1F33E}', '\u{1F331}', '\u{1F332}',
    '\u{1F333}', '\u{1F334}', '\u{1F335}', '\u{1F33A}', '\u{1F33B}', '\u{1F33C}', '\u{1F337}', '\u{1F339}',
    '\u{1F940}', '\u{1F33B}', '\u{1F338}', '\u{1F490}', '\u{1F344}', '\u{1F30D}', '\u{1F30E}', '\u{1F30F}',
  ],
  'Food & Drink': [
    '\u{1F347}', '\u{1F348}', '\u{1F349}', '\u{1F34A}', '\u{1F34B}', '\u{1F34C}', '\u{1F34D}', '\u{1F96D}',
    '\u{1F34E}', '\u{1F34F}', '\u{1F350}', '\u{1F351}', '\u{1F352}', '\u{1F353}', '\u{1FAD0}', '\u{1F95D}',
    '\u{1F345}', '\u{1FAD2}', '\u{1F965}', '\u{1F951}', '\u{1F346}', '\u{1F954}', '\u{1F955}', '\u{1F33D}',
    '\u{1F336}\u{FE0F}', '\u{1FAD1}', '\u{1F952}', '\u{1F96C}', '\u{1F966}', '\u{1F9C4}', '\u{1F9C5}', '\u{1F344}',
    '\u{1F95C}', '\u{1FAD8}', '\u{1F330}', '\u{1F35E}', '\u{1F950}', '\u{1F956}', '\u{1FAD3}', '\u{1F968}',
    '\u{1F96F}', '\u{1F95E}', '\u{1F9C7}', '\u{1F9C0}', '\u{1F356}', '\u{1F357}', '\u{1F969}', '\u{1F953}',
    '\u{1F354}', '\u{1F35F}', '\u{1F355}', '\u{1F32D}', '\u{1F96A}', '\u{1F32E}', '\u{1F32F}', '\u{1FAD4}',
    '\u{1F959}', '\u{1F9C6}', '\u{1F95A}', '\u{1F373}', '\u{1F958}', '\u{1F372}', '\u{1FAD5}', '\u{1F963}',
    '\u{1F957}', '\u{1F37F}', '\u{1F9C8}', '\u{1F9C2}', '\u{1F96B}', '\u{1F371}', '\u{1F358}', '\u{1F359}',
    '\u{1F35A}', '\u{1F35B}', '\u{1F35C}', '\u{1F35D}', '\u{1F360}', '\u{1F362}', '\u{1F363}', '\u{1F364}',
    '\u{1F365}', '\u{1F96E}', '\u{1F361}', '\u{1F95F}', '\u{1F960}', '\u{1F961}', '\u{1F980}', '\u{1F99E}',
    '\u{1F990}', '\u{1F991}', '\u{1F9AA}', '\u{1F366}', '\u{1F367}', '\u{1F368}', '\u{1F369}', '\u{1F36A}',
    '\u{1F382}', '\u{1F370}', '\u{1F9C1}', '\u{1F967}', '\u{1F36B}', '\u{1F36C}', '\u{1F36D}', '\u{1F36E}',
    '\u{1F36F}', '\u{1F37C}', '\u{1F95B}', '\u{2615}', '\u{1FAD6}', '\u{1F375}', '\u{1F376}', '\u{1F37E}',
    '\u{1F377}', '\u{1F378}', '\u{1F379}', '\u{1F37A}', '\u{1F37B}', '\u{1F942}', '\u{1F943}', '\u{1FAD7}',
    '\u{1F964}', '\u{1F9CB}', '\u{1F9C3}', '\u{1F9C9}', '\u{1F9CA}',
  ],
  'Activities & Sport': [
    '\u{26BD}', '\u{1F3C0}', '\u{1F3C8}', '\u{26BE}', '\u{1F94E}', '\u{1F3BE}', '\u{1F3D0}', '\u{1F3C9}',
    '\u{1F3B1}', '\u{1FA80}', '\u{1F3D3}', '\u{1F3F8}', '\u{1F94A}', '\u{1F94B}', '\u{1F945}', '\u{26F3}',
    '\u{1F3CC}\u{FE0F}', '\u{1F3F9}', '\u{1F3A3}', '\u{1F93F}', '\u{1F94C}', '\u{1F3BF}', '\u{26F7}\u{FE0F}', '\u{1F6F7}',
    '\u{1F3C2}', '\u{1F3CB}\u{FE0F}', '\u{1F93C}', '\u{1F938}', '\u{26F8}\u{FE0F}', '\u{1F6B4}', '\u{1F6B5}', '\u{1F938}',
    '\u{1F3AF}', '\u{1FA81}', '\u{1FA80}', '\u{1F3B2}', '\u{1F9E9}', '\u{265F}\u{FE0F}', '\u{1F3AE}', '\u{1F579}\u{FE0F}',
    '\u{1F3B0}', '\u{1F3B3}', '\u{1F3A8}', '\u{1F58C}\u{FE0F}', '\u{1F3AD}', '\u{1F3AC}', '\u{1F3A4}', '\u{1F3A7}',
    '\u{1F3BC}', '\u{1F3B5}', '\u{1F3B6}', '\u{1F941}', '\u{1F3B7}', '\u{1F3BA}', '\u{1F3B8}', '\u{1FA95}',
    '\u{1F3BB}', '\u{1FA98}', '\u{1F3B9}', '\u{1F3BC}',
  ],
  'Travel & Places': [
    '\u{1F697}', '\u{1F695}', '\u{1F699}', '\u{1F69A}', '\u{1F69B}', '\u{1F68C}', '\u{1F68E}', '\u{1F693}',
    '\u{1F694}', '\u{1F6FB}', '\u{1F6F4}', '\u{1F6F5}', '\u{1F3CD}\u{FE0F}', '\u{1F3CE}\u{FE0F}', '\u{1F6F2}', '\u{1F6B2}',
    '\u{1F6F4}', '\u{1F6F5}', '\u{1F6FA}', '\u{1F6E0}\u{FE0F}', '\u{1F69C}', '\u{1F6E4}\u{FE0F}', '\u{1F68B}', '\u{1F683}',
    '\u{1F69E}', '\u{1F69D}', '\u{1F684}', '\u{1F685}', '\u{1F688}', '\u{1F682}', '\u{1F687}', '\u{1F68A}',
    '\u{1F689}', '\u{1F680}', '\u{1F6F8}', '\u{1F6F0}\u{FE0F}', '\u{1F6CE}\u{FE0F}', '\u{1F9F3}', '\u{231B}', '\u{23F3}',
    '\u{1F6E5}\u{FE0F}', '\u{26F5}', '\u{1F6F6}', '\u{1F6A4}', '\u{1F6F3}\u{FE0F}', '\u{26F4}\u{FE0F}', '\u{1F6E2}\u{FE0F}', '\u{1F6E5}\u{FE0F}',
    '\u{2708}\u{FE0F}', '\u{1F6EB}', '\u{1F6EC}', '\u{1FA82}', '\u{1F4BA}', '\u{1F681}', '\u{1F69F}', '\u{1F6A0}',
    '\u{1F6A1}', '\u{1F699}', '\u{1F69D}', '\u{1F6F0}\u{FE0F}', '\u{1F306}', '\u{1F307}', '\u{1F309}', '\u{1F3D9}\u{FE0F}',
    '\u{1F303}', '\u{1F30C}', '\u{1F305}', '\u{1F304}', '\u{1F3DD}\u{FE0F}', '\u{1F3D6}\u{FE0F}', '\u{1F3DC}\u{FE0F}', '\u{1F3D4}\u{FE0F}',
    '\u{26F0}\u{FE0F}', '\u{1F30B}', '\u{1F5FB}', '\u{1F3D5}\u{FE0F}', '\u{1F3D8}\u{FE0F}', '\u{1F3E1}', '\u{1F3E0}', '\u{1F3DA}\u{FE0F}',
    '\u{1F3E2}', '\u{1F3E3}', '\u{1F3E4}', '\u{1F3E5}', '\u{1F3E6}', '\u{1F3E8}', '\u{1F3E9}', '\u{1F3EA}',
    '\u{1F3EB}', '\u{1F3EC}', '\u{1F3ED}', '\u{1F3EF}', '\u{1F3F0}', '\u{1F492}', '\u{1F5FC}', '\u{1F5FD}',
    '\u{26EA}', '\u{1F54C}', '\u{1F6D5}', '\u{1F54D}', '\u{26E9}\u{FE0F}', '\u{1F54B}',
  ],
  'Objects': [
    '\u{1F4F1}', '\u{1F4F2}', '\u{1F4BB}', '\u{2328}\u{FE0F}', '\u{1F5A5}\u{FE0F}', '\u{1F5A8}\u{FE0F}', '\u{1F5B1}\u{FE0F}', '\u{1F5B2}\u{FE0F}',
    '\u{1F579}\u{FE0F}', '\u{1F5DC}\u{FE0F}', '\u{1F4BD}', '\u{1F4BE}', '\u{1F4BF}', '\u{1F4C0}', '\u{1F4FC}', '\u{1F4F7}',
    '\u{1F4F8}', '\u{1F4F9}', '\u{1F3A5}', '\u{1F4FD}\u{FE0F}', '\u{1F39E}\u{FE0F}', '\u{1F4DE}', '\u{260E}\u{FE0F}', '\u{1F4DF}',
    '\u{1F4E0}', '\u{1F4FA}', '\u{1F4FB}', '\u{1F39A}\u{FE0F}', '\u{1F39B}\u{FE0F}', '\u{23F1}\u{FE0F}', '\u{23F2}\u{FE0F}', '\u{23F0}',
    '\u{1F570}\u{FE0F}', '\u{231B}', '\u{23F3}', '\u{1F4A1}', '\u{1F526}', '\u{1F56F}\u{FE0F}', '\u{1FA94}', '\u{1F4D4}',
    '\u{1F4D5}', '\u{1F4D6}', '\u{1F4D7}', '\u{1F4D8}', '\u{1F4D9}', '\u{1F4DA}', '\u{1F4DB}', '\u{1F4D2}',
    '\u{1F4C3}', '\u{1F4DC}', '\u{1F4C4}', '\u{1F4F0}', '\u{1F5DE}\u{FE0F}', '\u{1F4D1}', '\u{1F516}', '\u{1F3F7}\u{FE0F}',
    '\u{1F4B0}', '\u{1FA99}', '\u{1F4B4}', '\u{1F4B5}', '\u{1F4B6}', '\u{1F4B7}', '\u{1F4B8}', '\u{1F4B3}',
    '\u{1F9FE}', '\u{1F4B9}', '\u{2709}\u{FE0F}', '\u{1F4E7}', '\u{1F4E8}', '\u{1F4E9}', '\u{1F4E4}', '\u{1F4E5}',
    '\u{1F4E6}', '\u{1F4EB}', '\u{1F4EA}', '\u{1F4EC}', '\u{1F4ED}', '\u{1F4EE}', '\u{1F5F3}\u{FE0F}', '\u{270F}\u{FE0F}',
    '\u{2712}\u{FE0F}', '\u{1F58B}\u{FE0F}', '\u{1F58A}\u{FE0F}', '\u{1F58C}\u{FE0F}', '\u{1F58D}\u{FE0F}', '\u{1F4DD}', '\u{1F4BC}', '\u{1F4C1}',
    '\u{1F4C2}', '\u{1F5C2}\u{FE0F}', '\u{1F5D2}\u{FE0F}', '\u{1F5D3}\u{FE0F}', '\u{1F4C5}', '\u{1F4C6}', '\u{1F5D1}\u{FE0F}', '\u{1F4C7}',
    '\u{1F4C8}', '\u{1F4C9}', '\u{1F4CA}', '\u{1F4CB}', '\u{1F4CC}', '\u{1F4CD}', '\u{1F4CE}', '\u{1F587}\u{FE0F}',
    '\u{1F4CF}', '\u{1F4D0}', '\u{2702}\u{FE0F}', '\u{1F5C3}\u{FE0F}', '\u{1F5C4}\u{FE0F}', '\u{1F5D1}\u{FE0F}', '\u{1F512}', '\u{1F513}',
    '\u{1F50F}', '\u{1F510}', '\u{1F511}', '\u{1F5DD}\u{FE0F}', '\u{1F528}', '\u{1FA93}', '\u{26CF}\u{FE0F}', '\u{2692}\u{FE0F}',
    '\u{1F6E0}\u{FE0F}', '\u{1F5E1}\u{FE0F}', '\u{2694}\u{FE0F}', '\u{1F52B}', '\u{1F3F9}', '\u{1F6E1}\u{FE0F}', '\u{1F527}', '\u{1F529}',
    '\u{2699}\u{FE0F}', '\u{1F5DC}\u{FE0F}', '\u{2696}\u{FE0F}', '\u{1F9AF}', '\u{1F517}', '\u{26D3}\u{FE0F}', '\u{1FA9D}', '\u{1F9F0}',
    '\u{1F9F2}', '\u{1FA9C}', '\u{1F9EA}', '\u{1F9EB}', '\u{1F9EC}', '\u{1F52C}', '\u{1F52D}', '\u{1F4E1}',
    '\u{1F489}', '\u{1FA78}', '\u{1F48A}', '\u{1FA79}', '\u{1FA7C}', '\u{1FA7A}', '\u{1FA7B}', '\u{1F6AA}',
    '\u{1F6CF}\u{FE0F}', '\u{1F6CB}\u{FE0F}', '\u{1FA91}', '\u{1F6BD}', '\u{1F6BF}', '\u{1F6C1}', '\u{1F9F4}', '\u{1F9F7}',
  ],
  'Symbols': [
    '\u{1F535}', '\u{1F534}', '\u{1F7E0}', '\u{1F7E1}', '\u{1F7E2}', '\u{1F7E3}', '\u{1F7E4}', '\u{26AB}',
    '\u{26AA}', '\u{1F7E5}', '\u{1F7E7}', '\u{1F7E8}', '\u{1F7E9}', '\u{1F7E6}', '\u{1F7EA}', '\u{1F7EB}',
    '\u{2B1B}', '\u{2B1C}', '\u{25FE}', '\u{25FB}\u{FE0F}', '\u{25FC}\u{FE0F}', '\u{25FD}', '\u{25AA}\u{FE0F}', '\u{25AB}\u{FE0F}',
    '\u{1F532}', '\u{1F533}', '\u{1F4A0}', '\u{27A1}\u{FE0F}', '\u{2B05}\u{FE0F}', '\u{2B06}\u{FE0F}', '\u{2B07}\u{FE0F}', '\u{2197}\u{FE0F}',
    '\u{2198}\u{FE0F}', '\u{2199}\u{FE0F}', '\u{2196}\u{FE0F}', '\u{2195}\u{FE0F}', '\u{2194}\u{FE0F}', '\u{21A9}\u{FE0F}', '\u{21AA}\u{FE0F}', '\u{2934}\u{FE0F}',
    '\u{2935}\u{FE0F}', '\u{1F503}', '\u{1F504}', '\u{1F519}', '\u{1F51A}', '\u{1F51B}', '\u{1F51C}', '\u{1F51D}',
    '\u{2705}', '\u{2611}\u{FE0F}', '\u{2714}\u{FE0F}', '\u{2716}\u{FE0F}', '\u{274C}', '\u{274E}', '\u{2795}', '\u{2796}',
    '\u{2797}', '\u{27B0}', '\u{27BF}', '\u{303D}\u{FE0F}', '\u{2733}\u{FE0F}', '\u{2734}\u{FE0F}', '\u{2747}\u{FE0F}', '\u{203C}\u{FE0F}',
    '\u{2049}\u{FE0F}', '\u{2753}', '\u{2754}', '\u{2755}', '\u{2757}', '\u{3030}\u{FE0F}', '\u{00A9}\u{FE0F}', '\u{00AE}\u{FE0F}',
    '\u{2122}\u{FE0F}', '\u{0023}\u{FE0F}\u{20E3}', '\u{002A}\u{FE0F}\u{20E3}', '\u{0030}\u{FE0F}\u{20E3}', '\u{0031}\u{FE0F}\u{20E3}', '\u{0032}\u{FE0F}\u{20E3}', '\u{0033}\u{FE0F}\u{20E3}', '\u{0034}\u{FE0F}\u{20E3}',
    '\u{0035}\u{FE0F}\u{20E3}', '\u{0036}\u{FE0F}\u{20E3}', '\u{0037}\u{FE0F}\u{20E3}', '\u{0038}\u{FE0F}\u{20E3}', '\u{0039}\u{FE0F}\u{20E3}', '\u{1F51F}',
  ],
}

interface ChatInputProps {
  onSend: (text: string, attachments?: ChatAttachment[]) => void
  disabled: boolean
  /** Persona id used by the chat-reference picker to scope sessions. */
  personaId?: string
}

export function ChatInput({ onSend, disabled, personaId }: ChatInputProps) {
  const [text, setText] = useState('')
  const [showEmoji, setShowEmoji] = useState(false)
  const [showAttach, setShowAttach] = useState(false)
  const [attachments, setAttachments] = useState<ChatAttachment[]>([])
  const inputRef = useRef<HTMLTextAreaElement>(null)

  const handleSend = () => {
    const trimmed = text.trim()
    if (disabled) return
    if (!trimmed && attachments.length === 0) return
    onSend(trimmed, attachments.length > 0 ? attachments : undefined)
    setText('')
    setShowEmoji(false)
    // Revoke object URLs we created for image previews; the wire copy doesn't
    // hold them, so freeing the URLs doesn't break the message bubble (the
    // message itself only carries fileName + base64 data on the web client).
    for (const a of attachments) {
      if (a.previewUrl) {
        try { URL.revokeObjectURL(a.previewUrl) } catch { /* ignore */ }
      }
    }
    setAttachments([])
    if (inputRef.current) inputRef.current.style.height = 'auto'
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const handleInput = (e: Event) => {
    const target = e.target as HTMLTextAreaElement
    setText(target.value)
    target.style.height = 'auto'
    target.style.height = Math.min(target.scrollHeight, 120) + 'px'
  }

  const insertEmoji = (emoji: string) => {
    const ta = inputRef.current
    if (ta) {
      const start = ta.selectionStart ?? text.length
      const end = ta.selectionEnd ?? text.length
      const newText = text.slice(0, start) + emoji + text.slice(end)
      setText(newText)
      // Restore cursor position after emoji
      requestAnimationFrame(() => {
        ta.focus()
        const pos = start + emoji.length
        ta.setSelectionRange(pos, pos)
      })
    } else {
      setText(text + emoji)
    }
  }

  const removeAttachment = (index: number) => {
    setAttachments((prev) => {
      const att = prev[index]
      if (att?.previewUrl) {
        try { URL.revokeObjectURL(att.previewUrl) } catch { /* ignore */ }
      }
      return prev.filter((_, i) => i !== index)
    })
  }

  return (
    <div class="chat-input" style={{ position: 'relative', flexDirection: 'column', alignItems: 'stretch' }}>
      {showEmoji && (
        <div class="emoji-picker">
          {Object.entries(EMOJI_GROUPS).map(([group, emojis]) => (
            <div key={group} class="emoji-picker__group">
              <div class="emoji-picker__label">{group}</div>
              <div class="emoji-picker__grid">
                {emojis.map((e) => (
                  <button
                    key={e}
                    class="emoji-picker__btn"
                    onClick={() => insertEmoji(e)}
                    title={e}
                  >
                    {e}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {attachments.length > 0 && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 6,
          marginBottom: 8,
        }}>
          {attachments.map((att, i) => (
            <AttachmentChip
              key={`${att.fileName}-${i}`}
              attachment={att}
              onRemove={() => removeAttachment(i)}
            />
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
        <button
          class="chat-input__emoji"
          onClick={() => setShowAttach(true)}
          title="Add attachment"
          disabled={disabled}
          style={{ fontWeight: 600 }}
        >
          {'\u{002B}'}
        </button>
        <button
          class={`chat-input__emoji ${showEmoji ? 'chat-input__emoji--active' : ''}`}
          onClick={() => setShowEmoji((p) => !p)}
          title="Emoji"
        >
          {'\u{1F600}'}
        </button>
        <textarea
          ref={inputRef}
          class="chat-input__field"
          placeholder="Type a message..."
          value={text}
          onInput={handleInput}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          rows={1}
        />
        <button
          class="chat-input__send btn btn-primary"
          onClick={handleSend}
          disabled={disabled || (!text.trim() && attachments.length === 0)}
        >
          Send
        </button>
      </div>

      {showAttach && (
        <AttachmentPicker
          onClose={() => setShowAttach(false)}
          onAttach={(atts) => setAttachments((prev) => [...prev, ...atts])}
          personaId={personaId}
        />
      )}
    </div>
  )
}

function AttachmentChip({ attachment, onRemove }: { attachment: ChatAttachment; onRemove: () => void }) {
  const isImage = attachment.mimeType.startsWith('image/')
  const isPdf = attachment.mimeType === 'application/pdf'
  const icon = isImage ? '\u{1F5BC}\u{FE0F}' : isPdf ? '\u{1F4C4}' : '\u{1F4DD}'
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 6px 4px 8px',
      background: 'var(--bg-surface)',
      border: '1px solid var(--border)',
      borderRadius: 16,
      maxWidth: 240,
      fontSize: 12,
    }}>
      {isImage && attachment.previewUrl ? (
        <img
          src={attachment.previewUrl}
          alt=""
          style={{ width: 22, height: 22, borderRadius: 4, objectFit: 'cover' }}
        />
      ) : (
        <span style={{ fontSize: 14 }}>{icon}</span>
      )}
      <span style={{
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 180,
      }}>
        {attachment.fileName}
      </span>
      <button
        onClick={onRemove}
        title="Remove"
        style={{
          width: 18,
          height: 18,
          padding: 0,
          border: 'none',
          background: 'transparent',
          color: 'var(--text-muted)',
          cursor: 'pointer',
          lineHeight: 1,
          fontSize: 14,
        }}
      >
        {'\u{00D7}'}
      </button>
    </div>
  )
}
